import { Link } from "react-router-dom";
import StudentHeader from "../components/StudentHeader";
import { studentModules } from "../data/studentModules";
import { loadProgress, moduleStatus, statusLabels } from "../data/modulesStore";

function StudentModules() {
    const progress = loadProgress();
    const done = studentModules.filter((m) => moduleStatus(m, progress[m.id]) === 2).length;

    return (
        <>
            <StudentHeader title="Talabalar uchun o'quv ishlanmalari" crumb="Ishlanmalar" />
            <section className="pricing-one section-space-bottom">
                <div className="container">
                    <div className="pricing-one__main-tab-box tabs-box">
                        <div className="pricing-one__top">
                            <div className="pricing-one__content">
                                <h3 className="pricing-one__title">Amaliy mashg'ulot ishlanmalari</h3>
                                <p className="pricing-one__text">
                                    Har bir ishlanma bitta metodga bag'ishlangan tayyor amaliy mashg'ulot: maqsad va kutiladigan natijalar,
                                    tayanch tushunchalar, MTT uchun namunaviy mashg'ulot konspekti, uch darajali topshiriqlar,
                                    to'ldiriladigan ish varag'i va o'z-o'zini baholash mezonlari.
                                </p>
                            </div>
                        </div>
                        <div className="pricing-one__inner px-3 px-lg-5" style={{ paddingBottom: 40 }}>
                            <div className="d-flex justify-content-between mb-2" style={{ fontSize: 14, color: "#666" }}>
                                <span>Umumiy o'zlashtirish</span>
                                <span>{done} / {studentModules.length} ishlanma bajarilgan</span>
                            </div>
                            <div style={{ background: "#eee", borderRadius: 8, height: 8, marginBottom: 30 }}>
                                <div style={{ width: `${(done / studentModules.length) * 100}%`, background: "#10b981", height: "100%", borderRadius: 8 }} />
                            </div>

                            <div className="row gutter-y-30">
                                {studentModules.map((m, i) => {
                                    const st = statusLabels[moduleStatus(m, progress[m.id])];
                                    return (
                                        <div className="col-md-6 col-lg-4" key={m.id}>
                                            <Link to={`/student-modules/${m.id}`} style={{ display: "block", height: "100%", color: "inherit" }}>
                                                <div className="pricing-one__card" style={{ height: "100%", display: "flex", flexDirection: "column" }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span style={{ fontSize: 13, color: "#999" }}>{i + 1}-ishlanma · {m.hours}</span>
                                                        <span style={{ fontSize: 12, color: "#fff", background: st.color, padding: "2px 10px", borderRadius: 20 }}>{st.label}</span>
                                                    </div>
                                                    <h3 className="pricing-one__card__title" style={{ fontSize: 19 }}>{m.title}</h3>
                                                    <p className="pricing-one__card__text" style={{ flex: 1 }}>{m.goal}</p>
                                                    <span style={{ color: "#ffb606", fontWeight: 600 }}>Ishlanmani ochish →</span>
                                                </div>
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default StudentModules;
